module.exports = __webpack_public_path__ + "static/media/youtube-icon.95376c49.svg";